export const NEW_ENTITY_ID = 'new';
